// Hooks for appDefault

/*  Shared  */
import { LifecycleStatus, RiskLevel } from 'application/Shared/Constants';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useCallback, useState } from 'react';

interface PostAppDefaultParams {
    applicationId: string;
    status?: LifecycleStatus | null;
    risk?: RiskLevel | null;
    businessOwnerConfiguration?: string | null;
}

export const usePostAppDefault = () => {
    const [saving, setSaving] = useState(false);

    const postAppDefault = useCallback(async (params: PostAppDefaultParams) => {
        try {
            setSaving(true);
            await axios.post('/appDefault', params);
            return true; // success = true
        } catch (err) {
            debug.e('Could not save appDefaults', err);
            return false; // success = false
        } finally {
            setSaving(false);
        }
    }, []);

    return { postAppDefault, saving };
};
